import _ from "lodash";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";

import { providerRequests } from "@/api/(requests)/provider";

import GenericList from "../../Common/GenericList/GenericList";
import images from "../../../utils/images";

import "./styles.scss";

const DraftNotesTable = (props) => {
  const [notes, setNotes] = useState([]);
  const providerId = _.get(props, "match.params.providerId");

  useEffect(() => {
    (async () => {
      const data = {};

      if (providerId) {
        data["provider_id"] = providerId;
      }
      const response = await providerRequests.fetch_provider_draft_notes({ data });

      setNotes(response);
    })();
  }, []);

  const column_options = [
    {
      col_size: "col-4",
      display_name: "Patient Name",
      field_accessor: { key: "name", render_function: "" },
    },
    {
      col_size: "col-3",
      display_name: "Date of Service",
      field_accessor: { key: "date_of_service", render_function: "" },
    },
    {
      col_size: "col-3",
      display_name: "Last Updated",
      field_accessor: { key: "updated_date", render_function: "" },
    },
    {
      col_size: "col-1",
      display_name: "",
      field_accessor: { key: "icon", render_function: "" },
    },
  ];

  return (
    <div>
      <h3 className="fs-25 draft-notes-title tw:font-bold">Draft Notes</h3>
      <GenericList
        className="draft-notes-table"
        column_options={column_options}
        generic_list_key="date_of_service"
        grid_data={formatDraftNotes(notes, props.history)}
        headerClass="draft-notes-table-header"
      />
    </div>
  );
};

export const formatDraftNotes = (notes, router) => {
  return notes
    .map((note) => {
      const updated_date = note.updated_date || note.created_date;

      return {
        date_of_service: moment(
          `${note.session_date} ${note.session_from}`,
          "MM/DD/YYYY HH:mm",
        ).format("MM/DD/YYYY hh:mma"),
        icon: (
          <img
            alt="eye"
            className="pointer"
            onClick={() => router.push(`/app/patient/${note.patient_id}/note/${note.id}/v2`)}
            src={images("./icons/eye.svg")}
          />
        ),
        name: `${note.patient_first_name} ${note.patient_last_name}`,
        updated_date: moment.unix(updated_date).format("MM/DD/YYYY hh:mma"),
      };
    })
    .sort(
      (a, b) =>
        new Date(moment(b.date_of_service, "MM/DD/YYYY hh:mma").toISOString()) -
        new Date(moment(a.date_of_service, "MM/DD/YYYY hh:mma").toISOString()),
    );
};

export default DraftNotesTable;
